import './App.scss';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { AuthenticatedRoute } from 'components/routing';

import {
  Login,
  NCRForm,
  NCRTable,
  PageNotFound,
  ReturnTable,
  NCRRedirect,
} from 'views';

import axios from 'axios';

/**
 * This deals with the Switching of the routes and the loading of the relevant
 * components with in the application
 * @return {JSX.Element} -- App component
 * @constructor
 */
const App = () => {
  axios.defaults.withCredentials = true;

  return (
    <Switch>
      <Route exact path="/login">
        <Login />
      </Route>
      <AuthenticatedRoute exact path="/" component={NCRTable} />
      <AuthenticatedRoute exact path="/create" component={NCRForm} />
      <AuthenticatedRoute exact path="/create_return" component={NCRForm} />
      <AuthenticatedRoute exact path="/view_return" component={ReturnTable} />
      <AuthenticatedRoute exact path="/ncr/:id" component={NCRForm} />
      <AuthenticatedRoute exact path="/return/:id" component={NCRForm} />
      <AuthenticatedRoute
        exact
        path="/redirect/:type/:id"
        component={NCRRedirect}
      />
      <Route path="*">
        <PageNotFound />
      </Route>
    </Switch>
  );
};

export default App;
